import headsUpDude from 'images/characters/heads-up-dude.svg';

const HeadsUpAlert = () => {
  return (
    <div className=' row flex gap-3'>
      <img src={headsUpDude} />
      <div className='column'>
        <p className='font-bold'>Just a heads-up:</p>
        <p>
          Choosing a broad time range might result <br /> in slightly longer
          processing times.
        </p>
      </div>
    </div>
  );
};

export default HeadsUpAlert;
